// @generated by protoc-gen-es v2.10.1
// @generated from file common/v1/types.proto (package datifyy.common.v1, syntax proto3)
/* eslint-disable */

import { enumDesc, fileDesc, messageDesc, tsEnum } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file common/v1/types.proto.
 */
export const file_common_v1_types = /*@__PURE__*/
  fileDesc("ChVjb21tb24vdjEvdHlwZXMucHJvdG8SEWRhdGlmeXkuY29tbW9uLnYxIisKCVRpbWVzdGFtcBIPCgdzZWNvbmRzGAEgASgDEg0KBW5hbm9zGAIgASgFIo4BCgVFcnJvchIMCgRjb2RlGAEgASgJEg8KB21lc3NhZ2UYAiABKAkSNgoHZGV0YWlscxgDIAMoCzIlLmRhdGlmeXkuY29tbW9uLnYxLkVycm9yLkRldGFpbHNFbnRyeRouCgxEZXRhaWxzRW50cnkSCwoDa2V5GAEgASgJEg0KBXZhbHVlGAIgASgJOgI4ASJEChFQYWdpbmF0aW9uUmVxdWVzdBIMCgRwYWdlGAEgASgFEhEKCXBhZ2Vfc2l6ZRgCIAEoBRIOCgZjdXJzb3IYAyABKAkihgEKElBhZ2luYXRpb25SZXNwb25zZRIMCgRwYWdlGAEgASgFEhEKCXBhZ2Vfc2l6ZRgCIAEoBRITCgt0b3RhbF9jb3VudBgDIAEoAxITCgt0b3RhbF9wYWdlcxgEIAEoBRITCgtuZXh0X2N1cnNvchgFIAEoCRIQCghoYXNfbW9yZRgGIAEoCCJkCghMb2NhdGlvbhIUCgxjb3VudHJ5X2NvZGUYASABKAkSDwoHY291bnRyeRgCIAEoCRIMCgRjaXR5GAMgASgJEhAKCGxhdGl0dWRlGAQgASgBEhEKCWxvbmdpdHVkZRgFIAEoASq7AQoNQWNjb3VudFN0YXR1cxIeChpBQ0NPVU5UX1NUQVRVU19VTlNQRUNJRklFRBAAEhkKFUFDQ09VTlRfU1RBVFVTX0FDVElWRRABEhoKFkFDQ09VTlRfU1RBVFVTX1BFTkRJTkcQAhIcChhBQ0NPVU5UX1NUQVRVU19TVVNQRU5ERUQQAxIZChVBQ0NPVU5UX1NUQVRVU19CQU5ORUQQBBIaChZBQ0NPVU5UX1NUQVRVU19ERUxFVEVEEAUqwQEKElZlcmlmaWNhdGlvblN0YXR1cxIjCh9WRVJJRklDQVRJT05fU1RBVFVTX1VOU1BFQ0lGSUVEEAASIgoeVkVSSUZJQ0FUSU9OX1NUQVRVU19VTlZFUklGSUVEEAESHwobVkVSSUZJQ0FUSU9OX1NUQVRVU19QRU5ESU5HEAISIAocVkVSSUZJQ0FUSU9OX1NUQVRVU19WRVJJRklFRBADEh8KG1ZFUklGSUNBVElPTl9TVEFUVVNfRVhQSVJFRBAEKp0BCg5EZXZpY2VQbGF0Zm9ybRIfChtERVZJQ0VfUExBVEZPUk1fVU5TUEVDSUZJRUQQABIXChNERVZJQ0VfUExBVEZPUk1fV0VCEAESFwoTREVWSUNFX1BMQVRGT1JNX0lPUxACEhsKF0RFVklDRV9QTEFURk9STV9BTkRST0lEEAMSGwoXREVWSUNFX1BMQVRGT1JNX0RFU0tUT1AQBEK8AQoVY29tLmRhdGlmeXkuY29tbW9uLnYxQgpUeXBlc1Byb3RvUAFaMWdpdGh1Yi5jb20vZGF0aWZ5eS9iYWNrZW5kL2dlbi9jb21tb24vdjE7Y29tbW9udjGiAgNEQ1iqAhFEYXRpZnl5LkNvbW1vbi5WMcoCEURhdGlmeXlcQ29tbW9uXFYx4gIdRGF0aWZ5eVxDb21tb25cVjFcR1BCTWV0YWRhdGHqAhNEYXRpZnl5OjpDb21tb246OlYxYgZwcm90bzM");

/**
 * Describes the message datifyy.common.v1.Timestamp.
 * Use `create(TimestampSchema)` to create a new message.
 */
export const TimestampSchema = /*@__PURE__*/
  messageDesc(file_common_v1_types, 0);

/**
 * Describes the message datifyy.common.v1.Error.
 * Use `create(ErrorSchema)` to create a new message.
 */
export const ErrorSchema = /*@__PURE__*/
  messageDesc(file_common_v1_types, 1);

/**
 * Describes the message datifyy.common.v1.PaginationRequest.
 * Use `create(PaginationRequestSchema)` to create a new message.
 */
export const PaginationRequestSchema = /*@__PURE__*/
  messageDesc(file_common_v1_types, 2);

/**
 * Describes the message datifyy.common.v1.PaginationResponse.
 * Use `create(PaginationResponseSchema)` to create a new message.
 */
export const PaginationResponseSchema = /*@__PURE__*/
  messageDesc(file_common_v1_types, 3);

/**
 * Describes the message datifyy.common.v1.Location.
 * Use `create(LocationSchema)` to create a new message.
 */
export const LocationSchema = /*@__PURE__*/
  messageDesc(file_common_v1_types, 4);

/**
 * Describes the enum datifyy.common.v1.AccountStatus.
 */
export const AccountStatusSchema = /*@__PURE__*/
  enumDesc(file_common_v1_types, 0);

/**
 * Common user account status enum
 *
 * @generated from enum datifyy.common.v1.AccountStatus
 */
export const AccountStatus = /*@__PURE__*/
  tsEnum(AccountStatusSchema);

/**
 * Describes the enum datifyy.common.v1.VerificationStatus.
 */
export const VerificationStatusSchema = /*@__PURE__*/
  enumDesc(file_common_v1_types, 1);

/**
 * Verification status for email/phone
 *
 * @generated from enum datifyy.common.v1.VerificationStatus
 */
export const VerificationStatus = /*@__PURE__*/
  tsEnum(VerificationStatusSchema);

/**
 * Describes the enum datifyy.common.v1.DevicePlatform.
 */
export const DevicePlatformSchema = /*@__PURE__*/
  enumDesc(file_common_v1_types, 2);

/**
 * Common device platform types
 *
 * @generated from enum datifyy.common.v1.DevicePlatform
 */
export const DevicePlatform = /*@__PURE__*/
  tsEnum(DevicePlatformSchema);

